module.exports = __webpack_public_path__ + "img/vue.9378e368.jpg";